import { render, staticRenderFns } from "./Marki.vue?vue&type=template&id=5d9a5c24&scoped=true&"
import script from "./Marki.vue?vue&type=script&lang=js&"
export * from "./Marki.vue?vue&type=script&lang=js&"
import style0 from "./Marki.vue?vue&type=style&index=0&id=5d9a5c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a5c24",
  null
  
)

export default component.exports